// import React, { useState } from 'react';
// import { annualViewTabs as styles } from '../../css/styles/componentStyles'; 

// const AnnualViewTabs = ({activeTab, setActiveTab}) => {
//   const handleSlide = (direction) => {
//     if (direction === 'left' && activeTab === 'summary') {
//       setActiveTab('annual');
//     } else if (direction === 'right' && activeTab === 'annual') {
//       setActiveTab('summary');
//     }
//   };

//   return (
//     <div style={styles.tabHeader}>
//       <div style={styles.tabButtonContainer}>
//         <button
//           style={{
//             ...styles.tabButton,
//             ...(activeTab === 'annual' ? styles.activeTab : styles.inactiveTab)
//           }}
//           onClick={() => setActiveTab('annual')}
//         >
//           <i className="fa fa-calendar" style={{ fontSize: '18px' }}></i>
//           Annual
//         </button>
//         <button
//           style={{
//             ...styles.tabButton,
//             ...(activeTab === 'summary' ? styles.activeTab : styles.inactiveTab)
//           }}
//           onClick={() => setActiveTab('summary')}
//         >
//           <i className="fa fa-pie-chart" style={{ fontSize: '18px' }}></i>
//           Summary
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AnnualViewTabs;



import React, { useState } from 'react';
import { annualViewTabs as styles } from '../../css/styles/componentStyles'; 

const AnnualViewTabs = ({activeTab, setActiveTab}) => {
  const handleSlide = (direction) => {
    if (direction === 'left' && activeTab === 'summary') {
      setActiveTab('annual');
    } else if (direction === 'right' && activeTab === 'annual') {
      setActiveTab('summary');
    }
  };

  return (
    <div style={styles.tabHeader}>
      <div style={styles.tabButtonContainer}>
        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === 'annual' ? styles.activeTab : styles.inactiveTab)
          }}
          onClick={() => setActiveTab('annual')}
        >
          <i className="fa fa-calendar" style={{ fontSize: '18px' }}></i>
          Annual
        </button>
        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === 'summary' ? styles.activeTab : styles.inactiveTab)
          }}
          onClick={() => setActiveTab('summary')}
        >
          <i className="fa fa-pie-chart" style={{ fontSize: '18px' }}></i>
          Summary
        </button>
      </div>
    </div>
  );
};

export default AnnualViewTabs;

